module.exports = __webpack_public_path__ + "img/sld_scb_24_t1_b1.9252b91f.svg";